import {InitChartData} from '@/types/data';
import {Constants as constants} from '../config/constants';
import {Helpers} from '../common/helpers';

export class EventFactory {
    public static generateReinitChartEvent(data: InitChartData) {
        const event = new CustomEvent(constants.publicEvents.reinitChart, {
            detail: Helpers.doFullCopy(data)
        });
        window.dispatchEvent(event);
    }
}
